export default {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warning',
}

export const duplicateKeyViolationMsg =
    'duplicate key value violates unique constraint'
